var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderBgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 667,
    viewBox: "0 0 375 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.5 613.9C274.1 613.9 311.6 648.4 372.4 666.5H375V0H371.5C311 18.1 274.1 52.6 187.5 52.6C100.9 52.6 63.4 18.1 2.6 0H0V666.5H3.5C64 648.4 100.9 613.9 187.5 613.9Z",
    fill: "url(#paint0_linear_45_72)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.9 446.3C113.9 447 112.8 447.8 111.6 448.8C104.7 453.8 81.4999 470.3 56.8999 470.9C61.4999 472.1 66.3999 472.7 71.3999 472.7C84.6999 472.6 96.9999 468 106.6 460.2C110.3 455.9 113.1 451.3 114.9 446.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.6 450C118.1 448 119.5 445.8 120.8 443.6C120.4 443.4 119.9 443.5 119 443.9C118.3 445.9 117.5 448 116.6 450Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.4 429.9C121.2 433.5 120.7 437 119.9 440.4C120.9 440.2 121.7 440.2 122.4 440.5C125.2 434.8 127 428.5 127.7 421.8C125.5 425.3 123.7 427.8 121.4 429.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.1 413C120.9 417.1 121.4 421.3 121.5 425.4C124.4 423.2 126.6 420.5 128 417.3C128 416.7 128 416 128 415.4C128 409.9 127.2 404.6 125.7 399.6C125 404.3 123.6 409.4 120.1 413Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.3 409.2C122.7 406.3 124.3 400.3 122.9 391.9C113.8 372.2 93.9 358.5 70.7 358.7C69.3 358.7 68 358.8 66.7 358.9C92.9 362.6 112.8 384.5 119.3 409.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.9001 398.6C96.3 412.3 104.4 415.1 115.6 411.1C106.8 376 75.7001 359.7 54.6 361.1C41.9 364.9 31.1 373.1 23.8 383.8C33.7 381.5 42.3001 384.2 70.9001 398.6Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.3001 465.3C78.2001 463.5 104.7 448.5 108.1 446.8C109.6 446 113 443.5 116.3 441.8C117.1 438.8 117.6 435.7 117.8 432.5C113.4 435 107 436.8 95.6001 439.3C79.1001 444 44.1001 449.5 14.6001 424.5C17.4001 442.8 28.9001 458.2 44.8001 466.4C56.5001 468.7 60.3001 468.3 72.3001 465.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.9 435.8C102.8 433.8 111.4 431.5 117.9 427.8C117.9 425.3 117.7 422.7 117.3 420.1C117.1 418.6 116.9 417.2 116.6 415.7C111.3 418.6 102.9 419.1 89.6 414.4C75.7 407.9 44.2 387 30.7 387C27.9 387 25.4 386.1 21.8 386.9C16.8 395.4 14 405.4 14 416C14 417.4 14.1 418.7 14.2 420.1C25.3 431.9 59.8 445.5 93.9 435.8Z",
    fill: "#1C2624"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.9998 229.6C89.5998 229.9 89.1998 230.2 88.5998 230.6C85.7998 232.7 76.2998 239.4 66.2998 239.6C68.1998 240.1 70.1998 240.3 72.1998 240.3C77.5998 240.3 82.5998 238.4 86.5998 235.2C88.0998 233.5 89.1998 231.6 89.9998 229.6Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.6997 231.1C91.2997 230.3 91.8997 229.4 92.3997 228.5C92.2997 228.4 91.9997 228.4 91.5997 228.6C91.3997 229.4 90.9997 230.2 90.6997 231.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.5998 222.9C92.4998 224.3 92.2998 225.8 91.9998 227.2C92.3998 227.1 92.6998 227.1 92.9998 227.3C94.0998 225 94.8998 222.4 95.1998 219.7C94.2998 221 93.5998 222 92.5998 222.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.0999 216C92.3999 217.7 92.5999 219.4 92.6999 221.1C93.8999 220.2 94.7999 219.1 95.3999 217.8C95.3999 217.5 95.3999 217.3 95.3999 217C95.3999 214.8 95.0999 212.6 94.4999 210.6C94.0999 212.4 93.4999 214.5 92.0999 216Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.6998 214.4C93.0998 213.2 93.6998 210.8 93.1998 207.3C89.4998 199.3 81.3998 193.7 71.8998 193.7C71.2998 193.7 70.7998 193.7 70.2998 193.8C80.9998 195.4 89.0998 204.3 91.6998 214.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.9997 210.1C82.3997 215.7 85.6997 216.8 90.1997 215.2C86.5997 200.9 73.8997 194.2 65.2997 194.8C60.0997 196.4 55.6997 199.7 52.6997 204.1C56.7997 203.1 60.3997 204.2 71.9997 210.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.5997 237.3C74.9997 236.6 85.7997 230.5 87.1997 229.7C87.7997 229.4 89.1997 228.3 90.5997 227.7C90.8997 226.5 91.0997 225.2 91.1997 223.9C89.3997 224.9 86.7997 225.6 82.1997 226.7C75.4997 228.6 61.1997 230.8 49.1997 220.7C50.3997 228.2 54.9997 234.4 61.4997 237.8C66.0997 238.7 67.6997 238.5 72.5997 237.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M81.3998 225.3C84.9998 224.5 88.4998 223.6 91.1998 222C91.1998 221 91.0998 219.9 90.9998 218.9C90.8998 218.3 90.7998 217.7 90.6998 217.1C88.4998 218.3 85.0998 218.5 79.6998 216.6C73.9998 214 61.1998 205.4 55.6998 205.5C54.5998 205.5 53.4998 205.1 51.9998 205.5C49.9998 209 48.7998 213 48.7998 217.3C48.7998 217.9 48.7998 218.4 48.8998 219C53.3998 223.7 67.4998 229.2 81.3998 225.3Z",
    fill: "#1C2624"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.4 326.2C63.9 326.6 63.3 327 62.6 327.5C58.9 330.2 46.3 339.1 33 339.5C35.5 340.1 38.1 340.5 40.8 340.5C48 340.5 54.6 337.9 59.9 333.8C61.9 331.4 63.4 328.9 64.4 326.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.2998 328.1C66.0998 327 66.8998 325.9 67.4998 324.7C67.2998 324.6 66.9998 324.6 66.4998 324.8C66.1998 326 65.7998 327.1 65.2998 328.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.8999 317.3C67.7999 319.2 67.4999 321.1 67.0999 323C67.5999 322.9 68.0999 322.9 68.4999 323.1C69.9999 320 70.9999 316.6 71.3999 313C70.1999 314.8 69.1999 316.2 67.8999 317.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.2 308.1C67.7 310.3 67.9 312.6 67.9 314.8C69.5 313.6 70.7 312.2 71.4 310.4C71.4 310.1 71.4 309.7 71.4 309.4C71.4 306.4 70.9 303.6 70.1 300.9C69.9 303.4 69.1 306.2 67.2 308.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.7999 306.1C68.6999 304.5 69.4999 301.3 68.7999 296.7C63.8999 286 53.0999 278.7 40.5999 278.7C39.8999 278.7 39.0999 278.7 38.3999 278.8C52.4999 280.9 63.2999 292.7 66.7999 306.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.5999 300.4C54.3999 307.8 58.6999 309.3 64.7999 307.1C59.9999 288.1 43.1999 279.3 31.7999 280.1C24.8999 282.2 19.0999 286.6 15.0999 292.4C20.4999 291.1 25.1999 292.6 40.5999 300.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.4 336.4C44.6 335.4 58.8999 327.3 60.7999 326.4C61.5999 326 63.4999 324.6 65.1999 323.7C65.5999 322.1 65.9 320.4 66 318.7C63.5999 320 60.2 321 54 322.4C45.1 325 26.2 327.9 10.2 314.4C11.7 324.3 17.9 332.6 26.5 337.1C32.7999 338.3 34.9 338 41.4 336.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.9999 320.5C57.7999 319.4 62.3999 318.2 65.9999 316.2C65.9999 314.8 65.8999 313.4 65.6999 312C65.5999 311.2 65.4999 310.4 65.2999 309.6C62.3999 311.2 57.8999 311.4 50.6999 308.9C43.1999 305.4 26.0999 294.1 18.8999 294.1C17.3999 294.1 15.9999 293.6 14.0999 294C11.3999 298.6 9.8999 304 9.8999 309.7C9.8999 310.4 9.8999 311.2 9.9999 311.9C15.8999 318.4 34.5999 325.7 52.9999 320.5Z",
    fill: "#1C2624"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260 446.3C261 447 262.1 447.8 263.3 448.8C270.2 453.8 293.4 470.3 318 470.9C313.4 472.1 308.5 472.7 303.5 472.7C290.2 472.6 277.9 468 268.3 460.2C264.6 455.9 261.9 451.3 260 446.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.3 450C256.8 448 255.4 445.8 254.1 443.6C254.5 443.4 255 443.5 255.9 443.9C256.6 445.9 257.4 448 258.3 450Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M253.5 429.9C253.7 433.5 254.2 437 255 440.4C254 440.2 253.2 440.2 252.5 440.5C249.7 434.8 247.9 428.5 247.2 421.8C249.4 425.3 251.2 427.8 253.5 429.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M254.8 413C254 417.1 253.5 421.3 253.4 425.4C250.5 423.2 248.3 420.5 246.9 417.3C246.9 416.7 246.9 416 246.9 415.4C246.9 409.9 247.7 404.6 249.2 399.6C249.9 404.3 251.3 409.4 254.8 413Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.7 409.2C252.3 406.3 250.7 400.3 252.1 391.9C261.2 372.2 281.1 358.5 304.3 358.7C305.7 358.7 307 358.8 308.3 358.9C282.1 362.6 262.2 384.5 255.7 409.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M304.1 398.6C278.7 412.3 270.6 415.1 259.4 411.1C268.2 376 299.3 359.7 320.4 361.1C333.1 364.9 343.9 373.1 351.2 383.8C341.3 381.5 332.6 384.2 304.1 398.6Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.7 465.3C296.8 463.5 270.3 448.5 266.9 446.8C265.4 446 262 443.5 258.7 441.8C257.9 438.8 257.4 435.7 257.2 432.5C261.6 435 268 436.8 279.4 439.3C295.9 444 330.9 449.5 360.4 424.5C357.6 442.8 346.1 458.2 330.2 466.4C318.5 468.7 314.7 468.3 302.7 465.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M281.1 435.8C272.2 433.8 263.6 431.5 257.1 427.8C257.1 425.3 257.3 422.7 257.7 420.1C257.9 418.6 258.1 417.2 258.4 415.7C263.7 418.6 272.1 419.1 285.4 414.4C299.3 407.9 330.8 387 344.3 387.1C347.1 387.1 349.6 386.2 353.2 387C358.2 395.5 361 405.5 361 416.1C361 417.5 360.9 418.8 360.8 420.2C349.7 431.9 315.2 445.5 281.1 435.8Z",
    fill: "#1C2624"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M285 229.6C285.4 229.9 285.8 230.2 286.4 230.6C289.2 232.7 298.7 239.4 308.7 239.6C306.8 240.1 304.8 240.3 302.8 240.3C297.4 240.3 292.4 238.4 288.4 235.2C286.8 233.5 285.7 231.6 285 229.6Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M284.3 231.1C283.7 230.3 283.1 229.4 282.6 228.5C282.7 228.4 283 228.4 283.4 228.6C283.6 229.4 283.9 230.2 284.3 231.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.3 222.9C282.4 224.3 282.6 225.8 282.9 227.2C282.5 227.1 282.2 227.1 281.9 227.3C280.8 225 280 222.4 279.7 219.7C280.6 221 281.4 222 282.3 222.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.8 216C282.5 217.7 282.3 219.4 282.2 221.1C281 220.2 280.1 219.1 279.5 217.8C279.5 217.5 279.5 217.3 279.5 217C279.5 214.8 279.8 212.6 280.4 210.6C280.8 212.4 281.4 214.5 282.8 216Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.2 214.4C281.8 213.2 281.2 210.8 281.7 207.3C285.4 199.3 293.5 193.7 303 193.7C303.6 193.7 304.1 193.7 304.6 193.8C294 195.4 285.9 204.3 283.2 214.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.9 210.1C292.5 215.7 289.2 216.8 284.7 215.2C288.3 200.9 301 194.2 309.6 194.8C314.8 196.4 319.2 199.7 322.2 204.1C318.1 203.1 314.6 204.2 302.9 210.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.4 237.3C300 236.6 289.2 230.5 287.8 229.7C287.2 229.4 285.8 228.3 284.4 227.7C284.1 226.5 283.9 225.2 283.8 223.9C285.6 224.9 288.2 225.6 292.8 226.7C299.5 228.6 313.8 230.8 325.8 220.7C324.6 228.2 320 234.4 313.5 237.8C308.8 238.7 307.3 238.5 302.4 237.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M293.6 225.3C290 224.5 286.5 223.6 283.8 222C283.8 221 283.9 219.9 284 218.9C284.1 218.3 284.2 217.7 284.3 217.1C286.5 218.3 289.9 218.5 295.3 216.6C301 214 313.8 205.4 319.3 205.5C320.4 205.5 321.5 205.1 323 205.5C325 209 326.2 213 326.2 217.3C326.2 217.9 326.2 218.4 326.1 219C321.5 223.7 307.5 229.2 293.6 225.3Z",
    fill: "#1C2624"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.5 326.2C311 326.6 311.6 327 312.3 327.5C316 330.2 328.6 339.1 341.9 339.5C339.4 340.1 336.8 340.5 334.1 340.5C326.9 340.5 320.3 337.9 315 333.8C313 331.4 311.5 328.9 310.5 326.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M309.6 328.1C308.8 327 308 325.9 307.4 324.7C307.6 324.6 307.9 324.6 308.4 324.8C308.7 326 309.1 327.1 309.6 328.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307 317.3C307.1 319.2 307.4 321.1 307.8 323C307.3 322.9 306.8 322.9 306.4 323.1C304.9 320 303.9 316.6 303.5 313C304.8 314.8 305.8 316.2 307 317.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.7 308.1C307.2 310.3 307 312.6 307 314.8C305.4 313.6 304.2 312.2 303.5 310.4C303.5 310.1 303.5 309.7 303.5 309.4C303.5 306.4 304 303.6 304.8 300.9C305.1 303.4 305.8 306.2 307.7 308.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M308.2 306.1C306.3 304.5 305.5 301.3 306.2 296.7C311.1 286 321.9 278.7 334.4 278.7C335.1 278.7 335.9 278.7 336.6 278.8C322.4 280.9 311.7 292.7 308.2 306.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.4 300.4C320.6 307.8 316.3 309.3 310.2 307.1C315 288.1 331.8 279.3 343.2 280.1C350.1 282.2 355.9 286.6 359.9 292.4C354.5 291.1 349.8 292.6 334.4 300.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M333.6 336.4C330.4 335.4 316.1 327.3 314.2 326.4C313.4 326 311.5 324.6 309.8 323.7C309.4 322.1 309.1 320.4 309 318.7C311.4 320 314.8 321 321 322.4C329.9 325 348.8 327.9 364.8 314.4C363.3 324.3 357.1 332.6 348.5 337.1C342.1 338.3 340.1 338 333.6 336.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M321.9 320.5C317.1 319.4 312.5 318.2 308.9 316.2C308.9 314.8 309 313.4 309.2 312C309.3 311.2 309.4 310.4 309.6 309.6C312.5 311.2 317 311.4 324.2 308.9C331.7 305.4 348.8 294.1 356 294.1C357.5 294.1 358.9 293.6 360.8 294C363.5 298.6 365 304 365 309.7C365 310.4 365 311.2 364.9 311.9C359 318.4 340.3 325.7 321.9 320.5Z",
    fill: "#1C2624"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_72",
    x1: -72.8753,
    y1: 593.626,
    x2: 447.875,
    y2: 72.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9082A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 666.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBgMobile);
export default __webpack_public_path__ + "static/media/header-bg-mobile.898d0d0d1a64c752c8bcac42b38acc5d.svg";
export { ForwardRef as ReactComponent };